import React from 'react';
import  { connect } from 'react-redux';

import { filterByReturnTiming } from '../../../store/actions/flights';

import lateNightImage from '../../../assets/images/late-night.svg';
import morningImage from '../../../assets/images/morning.svg';
import eveningImage from '../../../assets/images/evening.svg';
import nightImage from '../../../assets/images/night.svg';

import FilterButtonLarge from '../FilterButtonLarge/FilterButtonLarge';

const filterReturn = (props) => (
    <div className={`u-flex`}>
        <FilterButtonLarge image={lateNightImage} isActive={props.returnActive.includes(0)} clicked={() => props.onFilterByReturnTiming(0)}>0-6hrs</FilterButtonLarge>
        <FilterButtonLarge image={morningImage} isActive={props.returnActive.includes(1)} clicked={() => props.onFilterByReturnTiming(1)}>6-12hrs</FilterButtonLarge>
        <FilterButtonLarge image={eveningImage} isActive={props.returnActive.includes(2)} clicked={() => props.onFilterByReturnTiming(2)}>12-18hrs</FilterButtonLarge>
        <FilterButtonLarge image={nightImage} isActive={props.returnActive.includes(3)} clicked={() => props.onFilterByReturnTiming(3)}>18-0hrs</FilterButtonLarge>
    </div>
)

const mapStateToProps = state => {
    return {
        returnActive: state.flights.selectedReturns
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onFilterByReturnTiming: (timeIndex) => dispatch(filterByReturnTiming(timeIndex))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(filterReturn);


// WEBPACK FOOTER //
// ./src/components/Filters/FilterReturn/FilterReturn.js